/**
 * this function returns false, if executed in the nodeJs backend
 */

export const isFrontend = () => {
  return typeof window !== 'undefined';
};
